<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="会议设置"
    ></div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <ul class="flex flex-wrap gap-y-3 gap-x-10 p-2.5">
        <div class="flex flex-col items-center">
          <text>报名人数限制</text>
          <el-input-number
            v-model="state.num"
            precision="0"
            class="number-input-left number-input-suffix !w-28"
            suffix="人"
          ></el-input-number>
        </div>
        <div class="flex flex-col items-center">
          <text>报名需审核</text>
          <el-radio-group
            v-model="state.bmxsh"
            :fill="state.bmxsh == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <div class="flex flex-col items-center">
          <text>团队报名</text>
          <el-radio-group
            v-model="state.tdbm"
            :fill="state.tdbm == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <div class="flex flex-col items-center">
          <text>修改需再次审核</text>
          <el-radio-group
            v-model="state.xgxsh"
            :fill="state.xgxsh == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <div class="flex flex-col items-center">
          <text>报名后允许修改</text>
          <el-radio-group
            v-model="state.bmhyxxg"
            :fill="state.bmhyxxg == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <div class="flex flex-col items-center">
          <text>报名结束后允许取消</text>
          <el-radio-group
            v-model="state.bmjshyxqx"
            :fill="state.bmjshyxqx == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <div class="flex flex-col items-center">
          <text>报名结束后允许修改</text>
          <el-radio-group
            v-model="state.bmjshyxxg"
            :fill="state.bmjshyxxg == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
        <!-- <div class="flex flex-col items-center">
          <text>门票模式</text>
          <el-radio-group v-model="state.xsh">
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div> -->
        <div class="flex flex-col items-center">
          <text>预算控制</text>
          <el-radio-group
            v-model="state.yskz"
            :fill="state.yskz == 1 ? '' : 'var(--el-color-danger)'"
          >
            <el-radio-button label="开启" :value="1" />
            <el-radio-button label="关闭" :value="0" />
          </el-radio-group>
        </div>
      </ul>
      <div
        class="flex-1 rounded-lg bg-white p-2.5 overflow-hidden flex flex-col"
      >
        <el-tabs v-model="state.menu" class="c-el-tabs-auto-height">
          <el-tab-pane label="项目人员" name="renyuan">
            <c_renyuan
              :meeting_id="props.meeting_id"
              v-if="state.menu == 'renyuan'"
            />
          </el-tab-pane>
          <el-tab-pane label="团队管理" name="tuandui">
            <c_404 />
            <!-- <c_tuandui
              :meeting_id="props.meeting_id"
              v-if="state.menu == 'tuandui'"
            /> -->
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_renyuan from "./RenYuan/List.vue";
import c_tuandui from "./TuanDui/List.vue";

export default {
  components: {
    c_renyuan,
    c_tuandui,
  },
  props: {
    meeting_id: Number,
  },
  setup(props) {
    const state = reactive({
      menu: "renyuan",
    });
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
